module.exports = __webpack_public_path__ + "static/media/3_7choi.dba1518a.png";